"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLeasingInput = exports.defaultLeasingInput = exports.priceOverrunLeasingExVat = exports.priceOverrunLeasing = void 0;
const enums_1 = require("../../enums");
exports.priceOverrunLeasing = 2.5;
exports.priceOverrunLeasingExVat = 2;
exports.defaultLeasingInput = {
    agreementCode: '',
    downPayment: 50000,
    durationMonths: 36,
    ignoreCampaigns: false,
    includeFeesInFinancedAmount: false,
    investedAmount: 0,
    isElectricVehicle: true,
    isObjectDirectlyImported: false,
    isObjectNew: true,
    manualAdministrationFee: 0,
    manualNominalInterest: 0,
    mileage: 10000,
    objectGroupCode: '130',
    objectMake: '',
    objectModel: '',
    registrationFee: 0,
    residualValue: 0,
    serviceAgreementPerYearFee: 0,
    tireHotelPerYearFee: 0,
};
const getLeasingInput = (override, customerType = enums_1.CustomerType.PRIVATE) => {
    return Object.assign(Object.assign(Object.assign({}, exports.defaultLeasingInput), override), { agreementCode: customerType === enums_1.CustomerType.BUSINESS ? '704' : '703' });
};
exports.getLeasingInput = getLeasingInput;
//# sourceMappingURL=leasing.js.map